// Copyright (c) 2017 Deere & Company

import actions from '../../actions-list';

export const updateShowNoResultsFound = hasNoResult => ({
    hasNoResult,
    type: actions.UPDATE_PIP_HISTORY_REPORT_SHOW_NO_RESULTS_FOUND
});



// WEBPACK FOOTER //
// ./src/reports/pip-history/action-creators/show-no-results-found.js